import * as React from "react";
import { Anchor } from "../typography/anchor/anchor.mjs";
class PaginationNumber extends React.Component {
  BEM() {
    const classArray = ["pagination-number"];
    if (this.props.color) {
      classArray.push("pagination-number--" + this.props.color);
    }
    if (this.props.position) {
      classArray.push("pagination-number--" + this.props.position);
    }
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  renderText(text) {
    return /* @__PURE__ */ React.createElement("p", { className: "pagination-number__text" }, text);
  }
  renderItem(index, item) {
    const { label, current, ...rest } = item;
    let classNames = "pagination-number__item";
    if (current) {
      classNames += " is-active";
    }
    return /* @__PURE__ */ React.createElement("li", { className: classNames, key: index }, /* @__PURE__ */ React.createElement(Anchor, { isUnderlined: false, ...rest, className: "pagination-number__link" }, label));
  }
  renderItems() {
    const items = this.props.items.map((item, i) => {
      return this.renderItem(i, item);
    });
    return /* @__PURE__ */ React.createElement("ul", { className: "pagination-number__items" }, items);
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: this.BEM() }, this.props.textLeft && this.renderText(this.props.textLeft), this.props.items && this.renderItems(), this.props.textRight && this.renderText(this.props.textRight));
  }
}
export {
  PaginationNumber
};
